import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import { Outlet } from 'react-router'

import ApiStatusWarning from '@/components/misc/ApiStatusWarning'
import LogoutWarning from '@/components/misc/LogoutWarning'
import NetworkStatusBar from '@/components/misc/NetworkStatusBar'
import RateLimitedWarning from '@/components/misc/RateLimitedWarning'
import UserChangedContextWarning from '@/components/misc/UserChangedContextWarning'
import { useIsPdf } from '@/hooks/useIsPdf'
import { useScrollToTopOnRouteChange } from '@/hooks/useScrollToTopOnRouteChange'
import { isDevelopment } from '@/lib/helpers/envHelpers'
import ClientMetadataProvider from '@/providers/ClientMetadataProvider'
import OfficeProvider from '@/providers/OfficeProvider'
import SessionProvider from '@/providers/SessionProvider'

const AppLayout: React.FC = () => {
  useScrollToTopOnRouteChange()

  const isPdf = useIsPdf()

  return (
    <OfficeProvider>
      <LogoutWarning />
      <UserChangedContextWarning />
      <RateLimitedWarning />

      <SessionProvider>
        <ClientMetadataProvider>
          <Outlet />
          {!isPdf && <ReactQueryDevtools buttonPosition="bottom-right" />}
          <NetworkStatusBar />
          {isDevelopment() && <ApiStatusWarning />}
        </ClientMetadataProvider>
      </SessionProvider>
    </OfficeProvider>
  )
}

export default AppLayout
